const RETENTION_MS = 7 * 24 * 60 * 60 * 1000;

// Keep IDs only, never notification text, prices or contact details. A first
// visit establishes a baseline; later visits can also show events missed offline.
export function consumeSalesEvents(events, previous, fetchedAt) {
  const validPrevious = previous && Number.isFinite(previous.since) && Array.isArray(previous.seen);
  const since = Math.max(validPrevious ? previous.since : fetchedAt, fetchedAt - RETENTION_MS);
  const seen = new Set(validPrevious ? previous.seen : []);
  const fresh = [];
  for (const event of [...events].sort((a, b) => a.occurredAt - b.occurredAt)) {
    if (validPrevious && event.occurredAt >= since && !seen.has(event.id)) fresh.push(event);
    seen.add(event.id);
  }
  return { fresh, ledger: { since, seen: [...seen].slice(-1000) } };
}

export function isSalesActivityResponse(value) {
  const validItem = (item) => item && typeof item.id === "string" && typeof item.title === "string"
    && typeof item.body === "string" && Number.isFinite(item.occurredAt)
    && typeof item.href === "string"
    && /^\/(?:verkaufen\/(?:gegenangebote\/|hoechstgebot\?|abwicklung\/)|profil\/gebote\/im-prozess\/)/.test(item.href);
  return Number.isFinite(value?.fetchedAt) && Array.isArray(value.events) && Array.isArray(value.tasks)
    && value.events.every(validItem) && value.tasks.every((item) => validItem(item) && Number.isFinite(item.validUntil));
}
